<template>
  <div v-bind="formChanged">
    <v-form ref="form" v-model="valid">
      <v-skeleton-loader v-if="loadingData" type="article"></v-skeleton-loader>
      <div v-else>
        <v-row>
          <v-col sm="3" md="3">
            <div class="tertiary--text text-body-2">
              {{ 
                $t(
                    'fleet_management.agents.agent_detail.labels.card_field_condition_name'
                  )  
              }}
            </div>
            <v-text-field
              id="idEventosNombreEditar"
              v-model.trim="dataForm.label"
              @blur="checkName"
              color="tertiary"
              counter="40"
              dense
              filled
              :error-messages="errorName"
              hide-details="auto"
              :readonly="!editable"
              required
              :rules="nameRules"
            ></v-text-field>
          </v-col>
          <v-col v-if="false" md="3">
            <div class="tertiary--text text-body-2">
              {{
                $t(
                  'fleet_management.agents.create.labels.create_gent_form_scope'
                )
              }}
            </div>
            <v-autocomplete
              v-if="editable"
              id="idEventosAlcanceEditar"
              :items="scopes"
              return-object
              v-model="selectedScope"
              dense
              filled
              color="tertiary"
            >
              <template v-slot:item="data">
                <v-list-item__title :id="data" class="dropdown-element-style">
                  {{ data.item }}
                </v-list-item__title>
              </template>
            </v-autocomplete>
            <div class="readonly mt-2">
              <span class="value secondary--text">
                {{ selectedScope }}
              </span>
            </div>
          </v-col>
        </v-row>
        <v-col md="7" class="pl-0">
          <v-row :key="index" v-for="(condition, index) in conditionsSelected">
            <v-col md="5">
              <div class="tertiary--text text-body-2">
                {{ 
                  $t(
                      'fleet_management.agents.agent_detail.labels.card_field_condition_condition'
                    )  
                }}
              </div>
              <div class="readonly mt-2">
                <span class="value secondary--text">
                  {{ condition.name }}
                </span>
              </div>
            </v-col>
            <v-row>
              <v-col cols="12" class="px-6">
                <component
                  @geofenceEmit="
                    geofences => {
                      geofenceEmit(geofences, index)
                    }
                  "
                  @speedEmit="
                    speed => {
                      speedEmit(speed, index)
                    }
                  "
                  @detention="
                    detention => {
                      detentionEmit(speed, index)
                    }
                  "
                  @batteryLowEmit="
                    battery => {
                      batteryLowEmit(battery, index)
                    }
                  "
                  @ralentiRpmEmit="
                    minutes => {
                      ralentiRpmEmit(minutes, index)
                    }
                  "
                  @fuelConsumptionDeviationEmit="
                    fuel => {
                      fuelConsumptionDeviationEmit(fuel, index)
                    }
                  "
                  @fuelTankEmit="
                    fuel => {
                      fuelTankEmit(fuel, index)
                    }
                  "
                  @tempSensor="tempSensorEmit"
                  :tempSensor="
                    dataForm.conditions['mrn:agent_condition:temperature']
                  "
                  @tempSensorMulti="tempSensorMultiEmit"
                  :tempSensorMulti="
                    dataForm.conditions['mrn:agent_condition:multi_temperature']
                  "
                  :key="formKey"
                  @engineTemp="engineTempEmit"
                  :engineTemp="
                    dataForm.conditions[
                      'mrn:agent_condition:engine_temperature'
                    ]
                  "
                  @rpmExcessive="
                    rpm => {
                      rpmExcessiveEmit(rpm, index)
                    }
                  "
                  @temperatureValid="tamperSensorValid"
                  @temperatureMultiValid="temperatureMultiValid"
                  @temperatureMultiChanged="forwardTemperatureMultiChanged"
                  @engineTemperatureValid="engineTempValid"
                  @rpmExcessiveValid="rpmExcValid"
                  @movementValidChild="movementValid"
                  @movement="movementEmit"
                  :movement="
                    dataForm.conditions['mrn:agent_condition:movement_start']
                  "
                  :is="agentComponent[index]"
                  v-bind="currentProperties(index)"
                ></component>
              </v-col>
            </v-row>
          </v-row>
        </v-col>
        <v-row>
          <v-col>
            <div class="divider-dotted"></div>
          </v-col>
        </v-row>
        <v-row v-if="!isConditionMovementStartOrLowBattery">
          <v-col md="6" offset-md="3">
            <time-limit
              :conditions="conditionsForTimeComponent"
              :contactOff="contactOff"
              @timeEmit="timeEmit"
              v-bind="currentTime"
            ></time-limit>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <time-restriction
              :valid="valid"
              @schedulingEmit="scheduling"
              :restrictionCron="cronFilter"
              :disable="editable"
            />
          </v-col>
        </v-row>
      </div>

      <v-row>
        <v-col cols="auto">
          <things-agent
            @thingsEmit="thingsEmitData"
            :conditionsForTimeComponent="conditionsForTimeComponent"
            v-bind="currentThings"
          ></things-agent>
        </v-col>
      </v-row>
      <v-row v-show="false" class="mb-7">
        <v-col align="end">
          <div class="d-flex justify-space-between">
            <v-btn depressed outlined rounded @click="cancel">{{
              $t(
                'fleet_management.agents.create.labels.create_agent_form_cancel_button'
              )
            }}</v-btn>
            <v-btn
              @click="confirmChanges"
              color="tertiary white--text"
              depressed
              :loading="submitLoading"
              rounded
              >{{
                $t(
                  'fleet_management.agents.create.labels.create_agent_form_accept_button'
                )
              }}</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </v-form>
    <Dialog
      @cancelButtonPressed="cancelDialog"
      :closeButtonText="dialog.closeButtonText"
      :loading="dialog.loading"
      :oneButton="dialog.oneButtonDialog"
      :oneButtonText="dialog.oneButtonText"
      @oneButtonAction="cancelDialog"
      :showDialog="showDialog"
      @submitButtonPressed="aceptDialog"
      :submitButtonText="dialog.acceptButtonText"
      :text="dialog.text"
      :type="dialog.type"
      ><template v-slot:extra-data v-if="repeatAgentName.label"> </template>
    </Dialog>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import { AgentsHelpers, GlobalHelpers } from '@/helpers/mainExports.js'
import SpeedLimit from '../SpeedLimit'
import ThingsAgent from '../ThingsAgent'
import GeofenceAgent from '../GeofenceAgent'
import LowBattery from '../LowBattery'
import Ralenti from '../Ralenti'
import FuelConsumptionDeviation from '../FuelConsumptionDeviation'
import FuelCharge from '../FuelCharge'
import TemperatureSensor from '../TemperatureSensor'
import DueUndueDriverDoor from '@/components/agents/partials/DueUndueDriverDoor.vue'
import DueUndueCargoGate from '@/components/agents/partials/DueUndueCargoGate.vue'
import DueUndueSemiDetach from '@/components/agents/partials/DueUndueSemiDetach.vue'
import EngineTemperature from '@/components/agents/partials/EngineTemperature.vue'
import RpmExcessive from '@/components/agents/partials/RpmExcessive.vue'
import TemperatureMultiSensor from '@/components/agents/partials/TemperatureMultiSensor.vue'

import Movement from '../Movement.vue'
import TimeLimit from '../TimeLimit'
import MainPower from '../MainPower.vue'
import FuelCut from '../FuelCut.vue'
import ignitionState from '../IgnitionState.vue'
import { SvgIcon } from '@leapsight/styleguide'
import Dialog from '@/components/dialog/Dialog'
import { i18n } from '@leapsight/portal'
import conditions_config from '@/helpers/agents/conditions_config'
import timeRestriction from '../../timeRestriction/timeRestriction.vue'

export default {
  name: 'conditions-component',
  components: {
    SpeedLimit,
    GeofenceAgent,
    TimeLimit,
    FuelCut,
    ThingsAgent,
    SvgIcon,
    Dialog,
    MainPower,
    ignitionState,
    timeRestriction,
    Movement,
    LowBattery,
    Ralenti,
    FuelConsumptionDeviation,
    DueUndueDriverDoor,
    DueUndueCargoGate,
    DueUndueSemiDetach,
    TemperatureSensor,
    FuelCharge,
    EngineTemperature,
    RpmExcessive,
    TemperatureMultiSensor
  },
  props: {
    isAdmin: {
      type: Boolean
    },
    editable: {
      type: Boolean
    }
  },
  data() {
    return {
      cronFilter: [],
      agentComponent: [], //Contiene los nombres de los componentes a utilizar
      conditionsList: [
        {
          name: 'Exceso de Velocidad',
          component: 'SpeedLimit',
          alias: 'mrn:agent_condition:speed_limit',
          id: 'mrn:agent_condition:speed_limit'
        },
        {
          name: 'Dentro de Zona',
          component: 'GeofenceAgent',
          id: 'mrn:agent_condition:geofence',
          alias: 'mrn:agent_condition:geofence_in',
          type: 'in'
        },
        {
          name: 'Fuera de Zona',
          component: 'GeofenceAgent',
          alias: 'mrn:agent_condition:geofence_out',
          id: 'mrn:agent_condition:geofence',
          type: 'out'
        },

        {
          name: 'Fuera de Zona',
          component: 'GeofenceAgent',
          alias: 'mrn:agent_condition:geofence_outside_all',
          id: 'mrn:agent_condition:geofence',
          type: 'outside_all'
        },
        {
          name: 'Desconexión de Bateria',
          component: 'MainPower',
          alias: 'mrn:agent_condition:main_power_off',
          id: 'mrn:agent_condition:main_power',
          type: false
        },
        {
          name: 'Conexión de Bateria',
          component: 'MainPower',
          alias: 'mrn:agent_condition:main_power_on',
          id: 'mrn:agent_condition:main_power',
          type: true
        },
        {
          name: 'Combustible Cortado',
          component: 'FuelCut',
          alias: 'mrn:agent_condition:fuel_cut_off',
          id: 'mrn:agent_condition:fuel_cut_off',
          type: false
        },
        {
          name: 'Combustible restablecido',
          component: 'FuelCut',
          alias: 'mrn:agent_condition:fuel_cut_off',
          id: 'mrn:agent_condition:fuel_cut_off',
          type: true
        },
        {
          name: 'En Contacto',
          component: 'contactOff',
          alias: 'mrn:agent_condition:ignition_on',
          id: 'mrn:agent_condition:ignition',
          type: true
        },
        {
          name: 'Sin Contacto',
          component: 'ignitionState',
          alias: 'mrn:agent_condition:ignition_off',
          id: 'mrn:agent_condition:ignition',
          type: false
        },
        {
          name: 'No Reporta',
          component: 'NoReport',
          alias: 'mrn:agent_condition:no_report',
          id: 'mrn:agent_condition:no_report',
          type: true
        },
        {
          name: 'Detención Prolongada',
          component: 'Detention',
          alias: 'mrn:agent_condition:detention',
          id: 'mrn:agent_condition:detention',
          type: 7
        },
        {
          name: 'Inicio de movimiento',
          component: 'Movement',
          alias: 'mrn:agent_condition:movement_start',
          id: 'mrn:agent_condition:movement_start',
          type: true
        },
        {
          name: 'Pánico',
          component: 'PanicButton',
          alias: 'mrn:agent_condition:panic_button',
          id: 'mrn:agent_condition:panic_button',
          type: true
        },
        {
          name: 'Apertura de lazo',
          component: 'LassoDisconnected',
          alias: 'mrn:agent_condition:lasso_disconnected',
          id: 'mrn:agent_condition:lasso_disconnected',
          type: true
        },
        {
          name: 'Antivandálico vulnerado',
          component: 'TamperSensor',
          alias: 'mrn:agent_condition:tamper_sensor',
          id: 'mrn:agent_condition:tamper_sensor',
          type: true
        },
        {
          name: 'Apertura de puerta',
          component: 'DueUndueDriverDoor',
          alias: 'mrn:agent_condition:driver_door',
          id: 'mrn:agent_condition:driver_door',
          type: true
        },
        {
          name: 'Apertura de portón',
          component: 'DueUndueCargoGate',
          alias: 'mrn:agent_condition:cargo_gate',
          id: 'mrn:agent_condition:cargo_gate',
          type: true
        },
        {
          name: 'Desenganche',
          component: 'DueUndueSemiDetach',
          alias: 'mrn:agent_condition:semi_detach',
          id: 'mrn:agent_condition:semi_detach',
          type: true
        },
        {
          name: 'Batería baja',
          component: 'LowBattery',
          alias: 'mrn:agent_condition:low_battery',
          id: 'mrn:agent_condition:low_battery'
        },
        {
          name: 'Ralenti excesivo',
          component: 'Ralenti',
          alias: 'mrn:agent_condition:ralenti',
          id: 'mrn:agent_condition:ralenti'
        },
        {
          name: 'Desvío de combustible',
          component: 'FuelConsumptionDeviation',
          alias: 'mrn:agent_condition:fuel_consumption_deviation',
          id: 'mrn:agent_condition:fuel_consumption_deviation'
        },
        {
          name: 'Sensor de temperatura',
          component: 'TemperatureSensor',
          alias: 'mrn:agent_condition:temperature',
          id: 'mrn:agent_condition:temperature',
          type: true
        },
        {
          name: 'Sensor de múltiples temperaturas',
          component: 'TemperatureMultiSensor',
          alias: 'mrn:agent_condition:multi_temperature',
          id: 'mrn:agent_condition:multi_temperature',
          type: true
        },
        {
          name: 'Carga de combustible',
          component: 'FuelCharge',
          alias: 'mrn:agent_condition:fuel_charge',
          id: 'mrn:agent_condition:fuel_charge'
        },
        {
          name: 'Parada No Autorizada',
          component: 'GenericSensor',
          alias: 'mrn:agent_condition:generic_unauthorized_stop',
          id: 'mrn:agent_condition:generic_unauthorized_stop'
        },
        {
          name: 'Puesta en Servicio',
          component: 'GenericSensor',
          alias: 'mrn:agent_condition:generic_put_into_service',
          id: 'mrn:agent_condition:generic_put_into_service'
        },
        {
          name: 'Quita de Servicio',
          component: 'GenericSensor',
          alias: 'mrn:agent_condition:generic_taken_out_of_service',
          id: 'mrn:agent_condition:generic_taken_out_of_service'
        },
        {
          name: 'Todavía Desenganchado',
          component: 'GenericSensor',
          alias: 'mrn:agent_condition:generic_still_detached',
          id: 'mrn:agent_condition:generic_still_detached'
        },
        {
          name: 'Evento de prueba',
          component: 'GenericSensor',
          alias: 'mrn:agent_condition:generic_event_test',
          id: 'mrn:agent_condition:generic_event_test'
        },
        {
          name: 'Pasajero detectado',
          component: 'GenericSensor',
          alias: 'mrn:agent_condition:generic_seat_passenger',
          id: 'mrn:agent_condition:generic_seat_passenger'
        },
        {
          name: 'Entrega',
          component: 'GenericSensor',
          alias: 'mrn:agent_condition:generic_delivery',
          id: 'mrn:agent_condition:generic_delivery'
        },
        {
          name: 'Giro Brusco',
          component: 'GenericSensor',
          alias: 'mrn:agent_condition:generic_sharped_turn',
          id: 'mrn:agent_condition:generic_sharped_turn'
        },
        {
          name: 'Frenada Brusca',
          component: 'GenericSensor',
          alias: 'mrn:agent_condition:generic_hard_brake',
          id: 'mrn:agent_condition:generic_hard_brake'
        },
        {
          name: 'Aceleración Brusca',
          component: 'GenericSensor',
          alias: 'mrn:agent_condition:generic_hard_acceleration',
          id: 'mrn:agent_condition:generic_hard_acceleration'
        },
        {
          name: 'Temperatura de motor',
          component: 'EngineTemperature',
          alias: 'mrn:agent_condition:engine_temperature',
          id: 'mrn:agent_condition:engine_temperature',
          type: true
        },
        {
          name: 'RPM excesivo',
          component: 'RpmExcessive',
          alias: 'mrn:agent_condition:excessive_rpm',
          id: 'mrn:agent_condition:excessive_rpm'
        }
      ],
      conditionsAmount: [], // Array con los ids de las condiciones ej:mrn:agent_condition:geofence
      conditionsSelected: [], // Condiciones actualmente seleccionadas
      conditionsForTimeComponent: [], //Condiciones para que el componente TimeLimit sepa que controles de tiempo habilitar
      conditionName: [],
      dataForm: {
        label: '',
        conditions: {},
        window: 0,
        things: {}
      },
      dataModifications: {},
      scopes: ['Corporativo', 'Propio'],
      selectedScope: '',
      originalScope: '',
      dataToProp: [],
      dataSpeed: 0, // Utilizado como apoyo para validar si el formulario sufrió cambios
      dataBatteryLow: 30,
      dataRalentiRpm: 800,
      dataRpmExcessive: 1500,
      dataFuelConsumptionDeviationPercentage: 800,
      dataFuelTankPercentage: 800,
      dataTemperatureSensorMaximum: 99,
      dataTemperatureSensorMinimum: -10,
      dataGeofence: {},
      dataToPropTime: '',
      dialog: {
        text: '',
        closeButtonText: i18n.t('general.dialogComponent.closeButtonText'),
        acceptButtonText: i18n.t('general.dialogComponent.acceptButtonText'),
        type: '',
        loading: false,
        oneButton: false,
        oneButtonText: ''
      },
      editable: true,
      errorName: '',
      geofencesUpdated: {}, // Utilizado como apoyo para validar si el formulario sufrió cambios
      nameRules: [
        v =>
          !!v || i18n.t('fleet_management.agents.create.errors.field_required'),
        v =>
          /[\w+À-ÿñÑ\s]{0,40}([^@;,])$/gi.test(v) ||
          i18n.t('fleet_management.agents.create.errors.invalid_name'),
        v =>
          v.length <= 40 ||
          i18n.t('fleet_management.agents.create.errors.name_length'),
        v =>
          v.length >= 2 ||
          i18n.t('fleet_management.agents.create.errors.name_length')
      ],
      oldAgent: {},
      propertiesFoo: [],
      repeatAgentName: '',
      submitLoading: false,
      selectedThings: [],
      showDialog: false,
      valid: true,
      newCron: '',
      oldCron: '',
      cronJobGetAgent: [],
      movementChanged: false,
      loadingData: false,
      showDueUndueComponent: false,
      contactOff: false,
      conditionsChanged: false
    }
  },
  methods: {
    ...mapActions('ui', ['setSnackbar']),
    ...mapActions('events', ['fillAgents']),
    scheduling(scheduling) {
      this.newCron = JSON.stringify(scheduling.cron_spec ?? [])
      if (scheduling.cron_spec) {
        scheduling.cron_spec = scheduling.cron_spec.map(cron => {
          const cronObj = {}
          const index = Object.keys(cron.value)
          for (const key in index) {
            cronObj[index[key]] = cron.value[key]
          }
          cron.value = cronObj
          return cron
        })
      }
      this.dataForm['scheduling'] = scheduling
      if (scheduling.cron_spec.length === 0) {
        delete this.dataForm['scheduling']
      }
      this.oldCron = JSON.stringify(this.cronJobGetAgent)
    },
    aceptDialog() {
      this.submit()
    },
    cancel() {
      this.resetValues()
      this.toggleEditable()
    },
    cancelDialog() {
      this.showDialog = false
      this.submitLoading = false
    },
    checkName() {
      if (this.editable) {
        const name = this.dataForm.label
        if (this.hasAgents) {
          const agents = this.agents
          for (let index = 0; index < agents.length; index++) {
            const element = agents[index]
            if (element.label === name && this.oldAgent.label !== name) {
              this.repeatAgentName = element
              this.showDialog = true
              this.dialog.type = 'warning'
              this.dialog.text = i18n.t(
                'fleet_management.agents.create.errors.agent_match'
              )
              this.dialog.oneButtonDialog = true
              this.dialog.oneButtonText = i18n.t(
                'general.dialogComponent.acceptButtonText'
              )
              this.errorName = i18n.t(
                'fleet_management.agents.create.errors.name_duplicated'
              )
            } else {
              this.errorName = ''
            }
          }
        }
        this.$set(this.dataModifications, 'label', name)
      }
    },
    confirmChanges() {
      this.submitLoading = true
      this.showDialog = true
      this.dialog.type = 'warning'
      this.dialog.text = i18n.t(
        'fleet_management.agents.alerts.confirm_changes'
      )
    },
    currentProperties(index) {
      const editModeValue = this.editable
      const dataPropValue = this.dataToProp[index]

      return { editMode: editModeValue, dataProp: dataPropValue }
    },
    fillForm() {
      this.dataModifications = {}
      //set how many conditions the agent has
      this.conditionsAmount = Object.keys(this.oldAgent.conditions)
      //set the label to the dataForm
      this.dataForm.label = this.oldAgent.label
      let element
      //Asociamos las condiciones previas al objeto que se va enviar en el update
      Object.assign(this.dataForm.conditions, this.oldAgent.conditions)
      Object.assign(this.dataForm.things, this.oldAgent.things)
      for (let index = 0; index < this.conditionsAmount.length; index++) {
        const conditionString = Object.keys(this.oldAgent.conditions)[index]
        const conditionValue = Object.values(this.oldAgent.conditions)[index]
        switch (conditionString) {
          case 'mrn:agent_condition:speed_limit':
            element = this.conditionsList.filter(
              condition => condition.id === 'mrn:agent_condition:speed_limit'
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            this.dataToProp.push(conditionValue.speed_limit)
            break
          case 'mrn:agent_condition:low_battery':
            element = this.conditionsList.filter(
              condition => condition.id === 'mrn:agent_condition:low_battery'
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            const batteryLowLevel = { ...conditionValue }.low_level
            this.dataToProp.push(batteryLowLevel)
            break
          case 'mrn:agent_condition:ralenti':
            element = this.conditionsList.filter(
              condition => condition.id === 'mrn:agent_condition:ralenti'
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            const maximumRalentiTime = { ...conditionValue }.rpm_limit
            this.dataToProp.push(maximumRalentiTime)
            break
          case 'mrn:agent_condition:fuel_consumption_deviation':
            element = this.conditionsList.filter(
              condition =>
                condition.id ===
                'mrn:agent_condition:fuel_consumption_deviation'
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            const fuelConsumptionDeviationPercentage = {
              ...conditionValue
            }.fuel_deviation
            this.dataToProp.push(fuelConsumptionDeviationPercentage)
            break
          case 'mrn:agent_condition:fuel_charge':
            element = this.conditionsList.filter(
              condition => condition.id === 'mrn:agent_condition:fuel_charge'
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            const fuelTankPercentage = {
              ...conditionValue
            }.fuel_limit
            this.dataToProp.push(fuelTankPercentage)
            break
          case 'mrn:agent_condition:main_power':
            element = this.conditionsList.filter(
              condition =>
                condition.id === 'mrn:agent_condition:main_power' &&
                conditionValue.main_power_on === condition.type
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            break
          case 'mrn:agent_condition:fuel_cut_off':
            element = this.conditionsList.filter(
              condition =>
                condition.id === 'mrn:agent_condition:fuel_cut_off' &&
                conditionValue.fuel_cut_off === !condition.type
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            break
          case 'mrn:agent_condition:ignition':
            element = this.conditionsList.filter(
              condition =>
                condition.id === 'mrn:agent_condition:ignition' &&
                conditionValue.contact_on === condition.type
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            break
          case 'mrn:agent_condition:geofence':
            element = this.conditionsList.filter(
              condition =>
                condition.id === 'mrn:agent_condition:geofence' &&
                conditionValue.type === condition.type
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)

            if (element.type === conditionValue.type) {
              const data = Object.entries(conditionValue.geofences)
              const arrGeofenceProp = []
              for (let index = 0; index < data.length; index++) {
                const element = data[index]
                const prop = { [element[0]]: element[1] }
                arrGeofenceProp.push(prop)
              }
              this.dataToProp.push(arrGeofenceProp)
            }
            break
          case 'mrn:agent_condition:no_report':
            element = this.conditionsList.filter(
              condition => condition.id === 'mrn:agent_condition:no_report'
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            break
          case 'mrn:agent_condition:detention':
            element = this.conditionsList.filter(
              condition =>
                condition.id === 'mrn:agent_condition:detention' &&
                conditionValue.min_speed === condition.type
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            break
          case 'mrn:agent_condition:movement_start':
            element = this.conditionsList.filter(
              condition =>
                condition.id === 'mrn:agent_condition:movement_start' &&
                conditionValue
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            break
          case 'mrn:agent_condition:temperature':
            element = this.conditionsList.filter(
              condition => condition.id === 'mrn:agent_condition:temperature'
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            const maximumTemperature = {
              max_temp: Number.parseFloat(conditionValue.max_temp).toFixed(1)
            }
            const minimumTemperature = {
              min_temp: Number.parseFloat(conditionValue.min_temp).toFixed(1)
            }
            this.dataToProp.push(maximumTemperature, minimumTemperature)
            break
          case 'mrn:agent_condition:multi_temperature':
            element = this.conditionsList.find(
              condition =>
                condition.id === 'mrn:agent_condition:multi_temperature'
            )
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)

            const sensorsArray = Object.entries(conditionValue || {}).map(
              ([key, sensor]) => ({
                sensor: key.replace('temperature', ''),
                min_temp: Number.parseFloat(sensor.min_temp).toFixed(1),
                max_temp: Number.parseFloat(sensor.max_temp).toFixed(1),
                minErrorMessage: '',
                maxErrorMessage: ''
              })
            )
            this.dataToProp.push(sensorsArray)
            break
          case 'mrn:agent_condition:panic_button':
            element = this.conditionsList.filter(
              condition =>
                condition.id === 'mrn:agent_condition:panic_button' &&
                conditionValue
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            break
          case 'mrn:agent_condition:lasso_disconnected':
            element = this.conditionsList.filter(
              condition =>
                condition.id === 'mrn:agent_condition:lasso_disconnected' &&
                conditionValue
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            break
          case 'mrn:agent_condition:tamper_sensor':
            element = this.conditionsList.filter(
              condition =>
                condition.id === 'mrn:agent_condition:tamper_sensor' &&
                conditionValue
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            break
          case 'mrn:agent_condition:driver_door':
          case 'mrn:agent_condition:driver_door_normal':
            element = this.conditionsList.filter(
              condition =>
                condition.id === 'mrn:agent_condition:driver_door' &&
                conditionValue
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            this.dataToProp.push(conditionString)
            break
          case 'mrn:agent_condition:cargo_gate':
          case 'mrn:agent_condition:cargo_gate_normal':
            element = this.conditionsList.filter(
              condition =>
                condition.id === 'mrn:agent_condition:cargo_gate' &&
                conditionValue
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            this.dataToProp.push(conditionString)
            break
          case 'mrn:agent_condition:semi_detach':
          case 'mrn:agent_condition:semi_detach_normal':
            element = this.conditionsList.filter(
              condition =>
                condition.id === 'mrn:agent_condition:semi_detach' &&
                conditionValue
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            this.dataToProp.push(conditionString)
            break
          case 'mrn:agent_condition:generic_unauthorized_stop':
            element = this.conditionsList.filter(
              condition =>
                condition.id ===
                  'mrn:agent_condition:generic_unauthorized_stop' &&
                conditionValue
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            break
          case 'mrn:agent_condition:generic_put_into_service':
            element = this.conditionsList.filter(
              condition =>
                condition.id ===
                  'mrn:agent_condition:generic_put_into_service' &&
                conditionValue
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            break
          case 'mrn:agent_condition:generic_taken_out_of_service':
            element = this.conditionsList.filter(
              condition =>
                condition.id ===
                  'mrn:agent_condition:generic_taken_out_of_service' &&
                conditionValue
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            break
          case 'mrn:agent_condition:generic_still_detached':
            element = this.conditionsList.filter(
              condition =>
                condition.id === 'mrn:agent_condition:generic_still_detached' &&
                conditionValue
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            break
          case 'mrn:agent_condition:generic_event_test':
            element = this.conditionsList.filter(
              condition =>
                condition.id === 'mrn:agent_condition:generic_event_test' &&
                conditionValue
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            break
          case 'mrn:agent_condition:generic_seat_passenger':
            element = this.conditionsList.filter(
              condition =>
                condition.id === 'mrn:agent_condition:generic_seat_passenger' &&
                conditionValue
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            break
          case 'mrn:agent_condition:generic_delivery':
            element = this.conditionsList.filter(
              condition =>
                condition.id === 'mrn:agent_condition:generic_delivery' &&
                conditionValue
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            break
          case 'mrn:agent_condition:generic_sharped_turn':
            element = this.conditionsList.filter(
              condition =>
                condition.id === 'mrn:agent_condition:generic_sharped_turn' &&
                conditionValue
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            break
          case 'mrn:agent_condition:generic_hard_brake':
            element = this.conditionsList.filter(
              condition =>
                condition.id === 'mrn:agent_condition:generic_hard_brake' &&
                conditionValue
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            break
          case 'mrn:agent_condition:generic_hard_acceleration':
            element = this.conditionsList.filter(
              condition =>
                condition.id ===
                  'mrn:agent_condition:generic_hard_acceleration' &&
                conditionValue
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            break
          case 'mrn:agent_condition:engine_temperature':
            element = this.conditionsList.filter(
              condition =>
                condition.id === 'mrn:agent_condition:engine_temperature'
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            const maximumEngineTemperature = {
              max_temp: Number.parseFloat(conditionValue.max_temp).toFixed(1)
            }
            this.dataToProp.push(maximumEngineTemperature)
            break
          case 'mrn:agent_condition:excessive_rpm':
            element = this.conditionsList.filter(
              condition => condition.id === 'mrn:agent_condition:excessive_rpm'
            )[0]
            this.conditionsSelected.push(element)
            this.conditionName.push(element)
            this.agentComponent.push(element.component)
            const maximumRpmExcessive = { ...conditionValue }.rpm_limit
            this.dataToProp.push(maximumRpmExcessive)
            break
        }
      }
      //se detecta cual condicion es la primaria
      //TODO ordenar las condiciones segun prioridad

      //esta funcion ordena las condiciones segun el criterio de prioridad dado por LJ
      this.rearrangeConditions()

      this.dataForm.window = this.oldAgent.window
      this.dataToPropTime = this.oldAgent.window
      //things
      if (this.oldAgent.hasOwnProperty('things')) {
        const dataArray = []
        const data = Object.entries(this.oldAgent.things)
        for (let index = 0; index < data.length; index++) {
          const element = data[index]
          const prop = { [element[0]]: element[1] }
          dataArray.push(prop)
        }
        this.selectedThings = dataArray
      }
    },
    rearrangeConditions() {
      if (this.conditionsSelected.length > 1) {
        const primaryKeys = Object.keys(conditions_config)
        const oneCondition = this.conditionsSelected[0]

        if (!primaryKeys.includes(oneCondition.alias)) {
          this.dataToProp = this.dataToProp.reverse()
          this.conditionName = this.conditionName.reverse()
          this.agentComponent = this.agentComponent.reverse()
          this.conditionsSelected = this.conditionsSelected.reverse()
        }

        const secondaryCondition = this.conditionsSelected[1]
        if (
          // eslint-disable-next-line @typescript-eslint/camelcase
          conditions_config[secondaryCondition.alias]?.includes(
            oneCondition.alias
          )
        ) {
          this.dataToProp = this.dataToProp.reverse()
          this.conditionName = this.conditionName.reverse()
          this.agentComponent = this.agentComponent.reverse()
          this.conditionsSelected = this.conditionsSelected.reverse()
        }

        if (this.dataToProp.length == 1) this.dataToProp.unshift({})
      }
    },
    async getAgent() {
      try {
        const agentId = this.$route.params.id
        const response = await AgentsHelpers.getAgent(agentId)
        this.$emit('newConditionsEmit', response.args[0].created_by)
        if (response.args[0].scheduling) {
          response.args[0].scheduling.cron_spec = response.args[0].scheduling.cron_spec.map(
            cron => {
              const cronArr = []
              const index = Object.keys(cron.value)
              for (const key in index) {
                cronArr.splice(index[key], 0, cron.value[index[key]])
              }
              cron.value = cronArr
              return cron
            }
          )
        }
        if (response.args[0].user_id) {
          this.originalScope = 'Propio'
          this.selectedScope = this.originalScope
        } else {
          this.originalScope = 'Corporativo'
          this.selectedScope = this.originalScope
        }
        this.oldAgent = response.args[0]
        if ('mrn:agent_condition:temperature' in this.oldAgent.conditions) {
          const {
            max_temp: maxTemp,
            min_temp: minTemp
          } = this.oldAgent.conditions['mrn:agent_condition:temperature']
          this.$set(
            this.oldAgent.conditions['mrn:agent_condition:temperature'],
            'max_temp',
            maxTemp.toFixed(1)
          )
          this.$set(
            this.oldAgent.conditions['mrn:agent_condition:temperature'],
            'min_temp',
            minTemp.toFixed(1)
          )
        }
        this.$store.commit('events/setCurrentAgent', {
          currentAgent: this.oldAgent
        })
        //Tener en cuenta que las condiciones para el componente de tiempo(window) deben presentarse en el mismo formato que utiliza el componente CreateAgent
        this.conditionsForTimeComponent = Object.keys(this.oldAgent.conditions)
        this.contactOff = this.conditionsForTimeComponent.some(
          condition =>
            condition === 'mrn:agent_condition:ignition' &&
            !this.oldAgent.conditions[condition]['contact_on']
        )
      } catch (error) {
        console.log(error)
      }
      this.cronJobGetAgent = this.oldAgent.scheduling
        ? this.oldAgent.scheduling.cron_spec
        : []
      const cron = JSON.stringify(this.cronJobGetAgent)
      this.cronFilter = AgentsHelpers.getFormatCronToDate(JSON.parse(cron))
    },
    geofenceEmit(data) {
      this.geofencesUpdated = data
      if (this.editable) {
        const geofences = {}
        for (let index = 0; index < data.length; index++) {
          const element = data[index]
          const id = element.id
          const name = element.properties.name
          geofences[id] = name
        }

        const key = 'conditions/mrn:agent_condition:geofence/geofence'
        this.$set(this.dataModifications, key, geofences)
      }
    },
    speedEmit(speed) {
      this.dataSpeed = speed
      const key = 'conditions/mrn:agent_condition:speed_limit/speed_limit'
      this.$set(this.dataModifications, key, speed)
    },
    batteryLowEmit(battery) {
      this.dataBatteryLow = battery
      const key = 'conditions/mrn:agent_condition:low_battery/low_level'
      this.$set(this.dataModifications, key, battery)
    },
    ralentiRpmEmit(rpm) {
      this.dataRalentiRpm = rpm
      const key = 'conditions/mrn:agent_condition:ralenti/rpm_limit'
      this.$set(this.dataModifications, key, rpm)
    },
    fuelConsumptionDeviationEmit(fuel) {
      this.dataFuelConsumptionDeviationPercentage = fuel
      const key =
        'conditions/mrn:agent_condition:fuel_consumption_deviation/fuel_deviation'
      this.$set(this.dataModifications, key, fuel / 100)
    },
    fuelTankEmit(fuel) {
      this.dataFuelTankPercentage = fuel
      const key = 'conditions/mrn:agent_condition:fuel_charge/fuel_limit'
      this.$set(this.dataModifications, key, fuel / 100)
    },
    movementEmit(movement) {
      const key = 'conditions/mrn:agent_condition:movement_start/movement_start'
      this.$set(this.dataModifications, key, movement)
    },
    tempSensorEmit(tempSensor) {
      const key = 'conditions/mrn:agent_condition:temperature/temperature'
      const { max_temp: maxTemp, min_temp: minTemp } = tempSensor
      this.$set(this.dataModifications, key, {
        max_temp: maxTemp.toFixed(1),
        min_temp: minTemp.toFixed(1)
      })
    },
    tempSensorMultiEmit(sensorData) {
      const key =
        'conditions/mrn:agent_condition:multi_temperature/temperature_multi_sensor'
      const formattedData = {}

      for (const [sensorKey, temps] of Object.entries(sensorData)) {
        formattedData[sensorKey] = {
          min_temp: parseFloat(temps.min_temp).toFixed(1),
          max_temp: parseFloat(temps.max_temp).toFixed(1)
        }
      }
      this.$set(this.dataModifications, key, formattedData)
    },
    engineTempEmit(engineTemp) {
      const key = 'conditions/mrn:agent_condition:engine_temperature'
      const { max_temp: engTemp } = engineTemp
      this.$set(this.dataModifications, key, {
        max_temp: engTemp.toFixed(1)
      })
    },
    rpmExcessiveEmit(rpm) {
      this.dataRpmExcessive = rpm
      const key = 'conditions/mrn:agent_condition:excessive_rpm/rpm_limit'
      this.$set(this.dataModifications, key, rpm)
    },
    resetValues() {
      //Reset de valores
      this.conditionsChanged = false
      this.conditionsSelected.splice(0)
      this.conditionName.splice(0)
      this.dataToProp.splice(0)
      this.selectedThings.splice(0)
      // this.selectedScope = this.originalScope
      this.formKey = Date.now() // Destruye el componente y lo vuelve a crear
      if (this.oldCron) {
        this.cronFilter = AgentsHelpers.getFormatCronToDate(
          JSON.parse(this.oldCron)
        )
      }
      if (
        this.oldAgent.conditions.hasOwnProperty('mrn:agent_condition:geofence')
      ) {
        this.geofencesUpdated = {}
      }
      Object.assign(this.dataForm, {
        label: '',
        conditions: {},
        window: 0,
        things: {},
        scheduling: {}
      })
      this.fillForm()
    },
    async submit() {
      const dataToUpdate = []
      const conditionFinal = this.dataForm.conditions

      const allModifications = Object.entries(this.dataModifications)
      for (let i = 0; i < allModifications.length; i++) {
        const element = allModifications[i]
        let key
        switch (element[0]) {
          case 'conditions/mrn:agent_condition:speed_limit/speed_limit':
            key = 'mrn:agent_condition:speed_limit'
            // eslint-disable-next-line @typescript-eslint/camelcase
            conditionFinal[key].speed_limit = element[1]
            break

          case 'conditions/mrn:agent_condition:low_battery/low_level':
            key = 'mrn:agent_condition:low_battery'
            // eslint-disable-next-line @typescript-eslint/camelcase
            conditionFinal[key].low_level = element[1]
            break
          case 'conditions/mrn:agent_condition:ralenti/rpm_limit':
            key = 'mrn:agent_condition:ralenti'
            // eslint-disable-next-line @typescript-eslint/camelcase
            conditionFinal[key].rpm_limit = element[1]
            break

          case 'conditions/mrn:agent_condition:fuel_consumption_deviation/fuel_deviation':
            key = 'mrn:agent_condition:fuel_consumption_deviation'
            // eslint-disable-next-line @typescript-eslint/camelcase
            conditionFinal[key].fuel_deviation = element[1]
            break
          case 'conditions/mrn:agent_condition:fuel_charge/fuel_limit':
            key = 'mrn:agent_condition:fuel_charge'
            // eslint-disable-next-line @typescript-eslint/camelcase
            conditionFinal[key].fuel_limit = element[1]
            break
          case 'conditions/mrn:agent_condition:geofence/geofence':
            key = 'mrn:agent_condition:geofence'
            conditionFinal[key].geofences = element[1]
            break
          case 'conditions/mrn:agent_condition:movement_start/movement_start':
            key = 'mrn:agent_condition:movement_start'
            conditionFinal[key] = element[1]
            break
          case 'conditions/mrn:agent_condition:temperature/temperature':
            key = 'mrn:agent_condition:temperature'
            const { min_temp: minTemp, max_temp: maxTemp } = element[1]
            const dataTemp = {
              min_temp: parseFloat(minTemp) + 0.0001,
              max_temp: parseFloat(maxTemp) + 0.0001
            }
            conditionFinal[key] = dataTemp
            break
          case 'conditions/mrn:agent_condition:multi_temperature/temperature_multi_sensor':
            key = 'mrn:agent_condition:multi_temperature'
            const dataTempMulti = {}

            for (const [sensorKey, temps] of Object.entries(element[1])) {
              dataTempMulti[sensorKey] = {
                min_temp: parseFloat(temps.min_temp) + 0.0001,
                max_temp: parseFloat(temps.max_temp) + 0.0001
              }
            }
            conditionFinal[key] = dataTempMulti
            break
          case 'conditions/mrn:agent_condition:engine_temperature':
            key = 'mrn:agent_condition:engine_temperature'
            const { max_temp: engTemp } = element[1]
            const dataEngineTemp = {
              max_temp: parseFloat(engTemp) + 0.0001
            }
            conditionFinal[key] = dataEngineTemp
            break
          case 'conditions/mrn:agent_condition:excessive_rpm/rpm_limit':
            key = 'mrn:agent_condition:excessive_rpm'
            // eslint-disable-next-line @typescript-eslint/camelcase
            conditionFinal[key].rpm_limit = element[1]
            break
          case 'things':
            if (element[1] == null) {
              const data = {
                action: 'remove',
                path: 'things'
              }
              dataToUpdate.push(data)
            } else {
              const data = {
                action: 'update',
                path: element[0],
                value: element[1]
              }
              dataToUpdate.push(data)
            }
            break

          default:
            const data = {
              action: 'update',
              path: element[0],
              value: element[1]
            }
            dataToUpdate.push(data)
            break
        }
      }
      const data = {
        action: 'update',
        path: 'conditions',
        value: conditionFinal
      }

      const scheduling = {
        action: this.dataForm.hasOwnProperty('scheduling')
          ? 'update'
          : 'remove',
        path: 'scheduling',
        ...(this.dataForm.hasOwnProperty('scheduling') && {
          value: this.dataForm.scheduling
        })
      }

      dataToUpdate.push(data, scheduling)
      if (dataToUpdate.length > 0) {
        this.submitLoading = true
        const agentId = this.oldAgent.id
        try {
          const response = await AgentsHelpers.updateAgent(
            agentId,
            dataToUpdate
          )
          this.showDialog = false
          this.submitLoading = false
          //Reset de valores
          this.oldAgent = Object.assign({}, response.args[0])

          this.resetValues()

          //Cerramos modo edición y se notifica al parent
          this.toggleEditable()
          if (response.args.length > 0) {
            const snackbar = {
              color: 'success',
              text: i18n.t('fleet_management.agents.alerts.edit_success')
            }
            this.setSnackbar(snackbar)
          } else {
            const snackbar = {
              text: i18n.t('fleet_management.agents.alerts.edit_error')
            }
            this.setSnackbar(snackbar)
          }
        } catch (e) {
          const snackbar = {
            text: i18n.t('fleet_management.agents.alerts.edit_error')
          }
          this.setSnackbar(snackbar)
        } finally {
          this.conditionsChanged = false
        }
      }
    },
    thingsEmitData(data) {
      const things = {}
      for (let index = 0; index < data.length; index++) {
        const element = data[index]
        const id = element.id
        const name = element.info.label
        things[id] = name
      }

      this.$emit('thingsChangedEmit', false)

      if (Object.keys(things).length > 0) {
        this.$set(this.dataModifications, 'things', things)
      } else {
        this.$set(this.dataModifications, 'things', null)
      }
    },
    timeEmit(time) {
      this.dataToPropTime = time
      this.dataForm.window = time
      this.dataModifications.window = time
    },
    toggleEditable() {
      this.editable = !this.editable
      this.$emit('conditionsEmit', this.editable)
    },
    movementValid(valid) {
      this.$emit('validConditionsEmit', valid)
      this.movementChanged = valid
    },
    tamperSensorValid(valid) {
      this.$emit('validConditionsEmit', valid)
    },
    temperatureMultiValid(valid) {
      this.$emit('validConditionsEmit', valid)
    },
    forwardTemperatureMultiChanged(changed) {
      this.$emit('temperatureMultiChanged', changed)
    },
    engineTempValid(valid) {
      this.$emit('validConditionsEmit', valid)
    },
    rpmExcValid(valid) {
      this.$emit('validConditionsEmit', valid)
    }
  },
  computed: {
    ...mapGetters('auth', ['connection']),
    ...mapGetters('events', ['hasAgents', 'agents']),
    ...mapState('auth', ['session']),
    isConditionMovementStartOrLowBattery() {
      if (!this.oldAgent.conditions) return false
      if (
        Object.keys(this.oldAgent.conditions).find(
          e =>
            e == 'mrn:agent_condition:movement_start' ||
            e == 'mrn:agent_condition:low_battery'
        )
      ) {
        return true
      } else {
        return false
      }
    },
    currentTime() {
      const editMode = this.editable
      const dataProp = this.dataToPropTime
      return { editMode, dataProp }
    },
    currentThings() {
      const editModeValue = this.editable
      const dataPropValue = this.selectedThings
      return { editMode: editModeValue, dataProp: dataPropValue }
    },
    formChanged() {
      let agentNameChanged = false
      let windowChanged = false
      let speedLimitChanged = false
      let geofencesChanged = false
      let thingsChanged = false
      let cronChanged = false

      if (Object.keys(this.oldAgent).length > 0) {
        //Verificar diferencia en el nombre
        if (this.dataForm.label !== this.oldAgent.label) agentNameChanged = true

        //Verificar diferencia en el window
        if (this.currentTime.dataProp !== this.oldAgent.window)
          windowChanged = true

        //Verificar diferencia entre el limite de velocidad original y el actual
        if (
          this.oldAgent.conditions.hasOwnProperty(
            'mrn:agent_condition:speed_limit'
          )
        ) {
          if (
            this.oldAgent.conditions['mrn:agent_condition:speed_limit']
              .speed_limit !== this.dataSpeed
          )
            speedLimitChanged = true
        }
        //Verificar diferencia entre listado de geofensas
        if (Object.keys(this.geofencesUpdated).length > 0) {
          const newGeofencesIds = this.geofencesUpdated.map(a => a.id)
          const originGeofencesIds = Object.keys(
            this.oldAgent.conditions['mrn:agent_condition:geofence'].geofences
          )
          if (
            !GlobalHelpers.haveSameContents(newGeofencesIds, originGeofencesIds)
          )
            geofencesChanged = true
        }

        //Verificar diferencias con listado de things
        if (typeof this.dataModifications.things !== 'undefined') {
          //El condicional ternario se debe a la situación en que, el agente parta de una configuración sin things asociados (oldAgent == undefined)
          //o bien que ya los tenga pero en la edición se quiten todos (dataModifications == null). Frente a esto no podemos utilizar Object.keys ya que arroja error
          const newThingsIds =
            this.dataModifications.things !== null
              ? Object.keys(this.dataModifications.things)
              : []
          const originalThingsIds =
            typeof this.oldAgent.things !== 'undefined'
              ? Object.keys(this.oldAgent.things)
              : []

          if (
            !GlobalHelpers.haveSameContents(newThingsIds, originalThingsIds)
          ) {
            thingsChanged = true
          }
        }
      }
      cronChanged = this.oldCron !== this.newCron

      const result =
        agentNameChanged ||
        windowChanged ||
        speedLimitChanged ||
        geofencesChanged ||
        thingsChanged ||
        cronChanged ||
        this.conditionsChanged
      // || this.selectedScope !== this.originalScope

      this.$emit('formChanged', result)
      return result
    }
  },
  watch: {
    async session(newSession) {
      //En caso que al inicio no hubiera una sesión abierta, observamos su estado
      //y cuando la misma este disponible obtenemos los datos
      //Escenario de uso: frente a un reload de página
      if (newSession.isOpen) {
        await this.getAgent()
        !this.hasAgents ? await this.fillAgents() : null
        this.fillForm()
        this.loadingData = false
      }
    },
    valid() {
      this.$emit('validConditionsEmit', this.valid)
    },
    dataModifications: {
      handler(newValue) {
        Object.keys(newValue).forEach(nv => {
          const keys = nv.split('/')
          if (keys.length > 2) {
            if (Boolean(this.oldAgent[keys[0]][keys[1]][keys[2]]))
              this.conditionsChanged =
                JSON.stringify(newValue[nv]) !==
                JSON.stringify(this.oldAgent[keys[0]][keys[1]][keys[2]])
            else {
              this.conditionsChanged =
                JSON.stringify(newValue[nv]) !==
                JSON.stringify(this.oldAgent[keys[0]][keys[1]])
            }
          }
        })
      },
      deep: true
    }
  },
  async created() {
    this.loadingData = true
    if (this.session.isOpen) {
      await this.getAgent()
      !this.hasAgents ? await this.fillAgents() : null
      this.fillForm()
      this.loadingData = false
    }
  }
}
</script>

<style scoped></style>
